import type { IconRuleSet } from '@vfuk/core-icon-generator'

// Setting up nonThemeableRules for use within the React component generator
export const nonThemeableRules: IconRuleSet = {
  packageName: 'SourceHiFiDarkIcons',
  defaultSize: 3,
  hasNumberBadge: false,
  size: {
    1: {
      sm: 64,
      md: 72,
      lg: 72,
      xl: 72,
    },
    2: {
      sm: 72,
      md: 84,
      lg: 84,
      xl: 84,
    },
    3: {
      sm: 84,
      md: 96,
      lg: 96,
      xl: 96,
    },
    4: {
      sm: 96,
      md: 120,
      lg: 120,
      xl: 120,
    },
    5: {
      sm: 120,
      md: 192,
      lg: 192,
      xl: 192,
    },
  },
  backgroundSize: {
    1: {
      sm: 88,
      md: 96,
      lg: 104,
      xl: 104,
    },
    2: {
      sm: 104,
      md: 124,
      lg: 124,
      xl: 124,
    },
    3: {
      sm: 124,
      md: 136,
      lg: 144,
      xl: 144,
    },
    4: {
      sm: 144,
      md: 176,
      lg: 184,
      xl: 184,
    },
    5: {
      sm: 184,
      md: 272,
      lg: 288,
      xl: 288,
    },
  },
}

const ruleSet = (): IconRuleSet => {
  return nonThemeableRules
}

export default ruleSet
